webpackJsonp([7],{

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "34+y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8UEl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "97Sy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f246b35_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("akCs");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f246b35_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_indicator_style_css__ = __webpack_require__("qONS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_indicator_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_indicator_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_indicator__ = __webpack_require__("UQTY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_indicator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_indicator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_toast_style_css__ = __webpack_require__("34+y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_toast_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_toast_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_toast__ = __webpack_require__("X+yh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_loadmore_style_css__ = __webpack_require__("ehhp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_loadmore_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_loadmore_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_loadmore__ = __webpack_require__("NVmV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_loadmore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_loadmore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mint_ui_lib_infinite_scroll_style_css__ = __webpack_require__("97Sy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mint_ui_lib_infinite_scroll_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mint_ui_lib_infinite_scroll_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_infinite_scroll__ = __webpack_require__("bCKv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_flexible__ = __webpack_require__("ZpAt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_flexible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__utils_flexible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_global__ = __webpack_require__("8UEl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_cookie__ = __webpack_require__("iPXC");


















__WEBPACK_IMPORTED_MODULE_8_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_8_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_infinite_scroll___default.a);
__WEBPACK_IMPORTED_MODULE_8_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_loadmore___default.a.name, __WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_loadmore___default.a);

__WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */].afterEach(function (to, from, next) {
  window.scrollTo(0, 0);
});

__WEBPACK_IMPORTED_MODULE_8_vue__["default"].filter('formatDate', function (str) {
  if (str) {
    return str.split(' ')[0];
  } else {
    return '';
  }
});
__WEBPACK_IMPORTED_MODULE_8_vue__["default"].http.options.emulateJSON = true;
__WEBPACK_IMPORTED_MODULE_8_vue__["default"].http.interceptors.push(function (request, next) {
  next(function (response) {
    // 跨域携带cookie
    request.credentials = true;
    // 请求发送后的处理逻辑
    request.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    // 根据请求的状态，response参数会返回给successCallback或errorCallback
    var data = response.body;
    if (response.status == 200 || response.status === 304 || response.status === 400) {
      if (data.code != '0001') {
        if (data.message) {
          __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_toast___default()(data.message);
        }
        return response;
      } else {
        return response;
      }
    } else {
      __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_toast___default()(response.status + '访问出错，请联系管理员');
      __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_indicator___default.a.close();
    }
  });
});
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_8_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_9__App__["a" /* default */]);
  }
});

// Vue.http.post('https://tradedev.worldunion.com.cn/apigw-ftdev4/trade/sysConfig/queryAppConfigs',
// Vue.http.post('/trade/sysConfig/queryAppConfigs',
//   {"segment1": "slacapp"}
//   ,{
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   }).then(function(res){
//     console.log(res)
//     // Vue.http.options.root = ‘http://vue.studyit.io/’;   //全局配置
//     // Cookie.set('baseUrl')


// }, function(error){
//     console.log(error)
// });

/***/ }),

/***/ "ULTG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
//路由跳转新页面 默认显示在最顶端

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ZSCT")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '验证工号',
      keepAlive: false
    }
  }, {
    path: '/ForgetPwd',
    name: 'ForgetPwd',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("cJNM")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '忘记密码',
      keepAlive: false
    }
  }, {
    path: '/ChangeResult',
    name: 'ChangeResult',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("uz0H")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '重设密码结果',
      keepAlive: false
    }
  },
  // ===== 供应商VPN密码自助重置（入口: index.html#/VendorAccount）=====
  {
    path: '/VendorAccount',
    name: 'VendorAccount',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("fSod")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '重置密码',
      keepAlive: false
    }
  }, {
    path: '/VendorReset',
    name: 'VendorReset',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("UNdT")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '重置密码',
      keepAlive: false
    }
  }, {
    path: '/VendorResult',
    name: 'VendorResult',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("FGJQ")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '操作结果',
      keepAlive: false
    }
  }]
}));

/***/ }),

/***/ "ZpAt":
/***/ (function(module, exports) {


;(function (win, lib) {
    var doc = win.document;
    var docEl = doc.documentElement;
    var metaEl = doc.querySelector('meta[name="viewport"]');
    var flexibleEl = doc.querySelector('meta[name="flexible"]');
    var dpr = 0;
    var scale = 0;
    var tid;
    var flexible = lib.flexible || (lib.flexible = {});

    if (metaEl) {
        console.warn('将根据已有的meta标签来设置缩放比例');
        var match = metaEl.getAttribute('content').match(/initial\-scale=([\d\.]+)/);
        if (match) {
            scale = parseFloat(match[1]);
            dpr = parseInt(1 / scale);
        }
    } else if (flexibleEl) {
        var content = flexibleEl.getAttribute('content');
        if (content) {
            var initialDpr = content.match(/initial\-dpr=([\d\.]+)/);
            var maximumDpr = content.match(/maximum\-dpr=([\d\.]+)/);
            if (initialDpr) {
                dpr = parseFloat(initialDpr[1]);
                scale = parseFloat((1 / dpr).toFixed(2));
            }
            if (maximumDpr) {
                dpr = parseFloat(maximumDpr[1]);
                scale = parseFloat((1 / dpr).toFixed(2));
            }
        }
    }

    if (!dpr && !scale) {
        var isAndroid = win.navigator.appVersion.match(/android/gi);
        var isIPhone = win.navigator.appVersion.match(/iphone/gi);
        var devicePixelRatio = win.devicePixelRatio;
        if (isIPhone) {
            // iOS下，对于2和3的屏，用2倍的方案，其余的用1倍方案
            if (devicePixelRatio >= 3 && (!dpr || dpr >= 3)) {
                dpr = 3;
            } else if (devicePixelRatio >= 2 && (!dpr || dpr >= 2)) {
                dpr = 2;
            } else {
                dpr = 1;
            }
        } else {
            // 其他设备下，仍旧使用1倍的方案
            dpr = 1;
        }
        scale = 1 / dpr;
    }

    docEl.setAttribute('data-dpr', dpr);
    if (!metaEl) {
        metaEl = doc.createElement('meta');
        metaEl.setAttribute('name', 'viewport');
        metaEl.setAttribute('content', 'initial-scale=' + scale + ', maximum-scale=' + scale + ', minimum-scale=' + scale + ', user-scalable=no');
        if (docEl.firstElementChild) {
            docEl.firstElementChild.appendChild(metaEl);
        } else {
            var wrap = doc.createElement('div');
            wrap.appendChild(metaEl);
            doc.write(wrap.innerHTML);
        }
    }

    function refreshRem() {
        var width = docEl.getBoundingClientRect().width;
        if (width / dpr > 540) {
            width = 540 * dpr;
        }
        var rem = width / 7.5;
        docEl.style.fontSize = rem + 'px';
        flexible.rem = win.rem = rem;
    }

    win.addEventListener('resize', function () {
        clearTimeout(tid);
        tid = setTimeout(refreshRem, 300);
    }, false);
    win.addEventListener('pageshow', function (e) {
        if (e.persisted) {
            clearTimeout(tid);
            tid = setTimeout(refreshRem, 300);
        }
    }, false);

    if (doc.readyState === 'complete') {
        doc.body.style.fontSize = 12 * dpr + 'px';
    } else {
        doc.addEventListener('DOMContentLoaded', function (e) {
            doc.body.style.fontSize = 12 * dpr + 'px';
        }, false);
    }

    refreshRem();

    flexible.dpr = win.dpr = dpr;
    flexible.refreshRem = refreshRem;
    flexible.rem2px = function (d) {
        var val = parseFloat(d) * this.rem;
        if (typeof d === 'string' && d.match(/rem$/)) {
            val += 'px';
        }
        return val;
    };
    flexible.px2rem = function (d) {
        var val = parseFloat(d) / this.rem;
        if (typeof d === 'string' && d.match(/px$/)) {
            val += 'rem';
        }
        return val;
    };
})(window, window['lib'] || (window['lib'] = {}));

/***/ }),

/***/ "akCs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),_vm._v(" "),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ehhp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iPXC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(name) {
    var arr,
        reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg)) {
      return unescape(arr[2]);
    } else {
      return null;
    }
  },
  set: function set(name, value) {
    var Days = 30;
    var exp = new Date();
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
  },
  remove: function remove(name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = this.get(name);
    if (cval != null) document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
  }
});

/***/ }),

/***/ "qONS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  watch: {
    '$route': function $route(to, from) {
      document.title = to.meta.title;
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.82ce9f5cdca8d2fd3737.js